



export default function ErrorPage() {

    return (
        <div className="fl-cl errorPage__container" id="error-page">
            <h1>Oops!</h1>
            <p>Ocurrió algún error</p>
            <p>Por favor utilizá la barra de navegación</p>
            {/* <p>
                <i>{error.statusText || error.message}</i>
            </p> */}
        </div>
    );
}